import React, { useState, useEffect } from "react";
import { FormControl, TextField, Button, Grid, Box } from "@mui/material";
import { Icon, DatePicker, useToggle } from "@genesis/ui-kit";
import axios from "axios";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { useNavigate, NavLink, useLocation } from "react-router-dom";
import { CheckIsUserAdmin, } from "../../../Shared/Utill/Utills";
import SnackBar from "../../../Shared/Snackbar/Snackbar";
import DivisionDropDownComp from "../DivisionDropdown/DivisionDropdownComp";
import {
  AddPlusIcon,
  SearchIcon,
} from "../../../Resources/availabilityicon/IconUtils";
import AdminControlsDataGrid from "../AdminControlsDataGrid";
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { constants } from "../../../Shared/Url/Constants";
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreHoriz';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import moment from 'moment';
import classes from "./advancesearch.module.scss";
import { isString } from '../../../Shared/Utill/Utills';
import axiosInstance from "../../../Shared/Utill/AxiosConfig";


const AdvanceSearch = () => {
  const personDetails = useSelector(
    (state) => state.personStatic.personStaticData
  );
  const urlDetails = useSelector((state) => state.url.urlData);
  const token = Cookies.get("X_TKN");
  const history = useNavigate();
  const [divSelectedValue, setDivSelectedValue] = useState(null);
  const [workSchedule, setWorkSchedule] = useState(null);
  const [ruleId, setRuleId] = useState(null);
  const [groupId, setGroupId] = useState(null);
  const [searchLocation, setSearchLocation] = useState(null);
  const [scheduleArea, setScheduleArea] = useState(null);
  const [effectiveDate, setEffectiveDate] = useState(null);
  const [isAlertOpen, setAlertOpen] = React.useState({});
  const { message, severity, open } = isAlertOpen || {};
  const location = useLocation();
  const [searchValue, setSearchValue] = useState([]);
  const [searchApiValue, setSearchApiValue] = useState([]);

  const [selectedRowData, setSelectedRowData] = useState(null);

  const ITEM_HEIGHT = 48;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openOption = Boolean(anchorEl);
  const dialog = useToggle();

  // action options
  const options = [
    'Work Schedule Grp',
    'Rules',
    'Assignment',
    'Preference Groups',
  ];


  // check user role at page
  CheckIsUserAdmin();

  const onDivDropDownSelect = (selectedDivision) => {
    setDivSelectedValue(selectedDivision);
  };

  const handleAlertNotifClose = () => {
    setAlertOpen({});
  };

  // option menu callbacks
  const handleClick = (event, data) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowData(data);
  };

  const handleClose = (event) => {
    setAnchorEl(null);
  };

  const handleOptionMenuClick = (event) => {
    setAnchorEl(null);
    let optionClicked = event.nativeEvent.target.outerText;
    let myData = selectedRowData;

    if (optionClicked == 'Work Schedule Grp') {
      history("/controls/availabilityapplicationcontrols/workschedulegrouping/Edit", { state: { id: myData.wsId, flag: "E" } });
    }

    if (optionClicked == 'Rules') {
      history("/controls/availabilityapplicationcontrols/rules/Edit", { state: { id: myData.arId, flag: "E" } });
    }

    if (optionClicked == 'Assignment') {
      history("/controls/availabilityapplicationcontrols/ruleassignments/Edit", { state: { id: myData.araId, flag: "E" } });
    }

    if (optionClicked == 'Preference Groups') {
      // call api to get locid and appid
      let data = {
        divNbr: myData.divNbr,
        appAbbr: "avl",
        locNbr: myData.locNbr,
        ctlName: "ACTIVE"
    }

     axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_DIV_APP_LOC_CTL}`, 
     data,
      {
        headers:{
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + token,
        }
      }).then((res) => {
        let data = res.data && res.data[0];
        let tmpobj = {}
        tmpobj.appid = data.appid;
        tmpobj.division = data.divNbr + "-"+data.divName;
        tmpobj.divnbr = data.divNbr;
        tmpobj.locid = data.locid;
        tmpobj.prefLocation = data.locNbr;
        
        history("/controls/availabilityapplicationcontrols/locationcontrols/Edit", { state: {flag: "E", id: myData.pwhGrpNbr, data: tmpobj }});
        console.log(res)
      }).catch((err) => {
        if(err.message === 'Network Error') {
          history("/somethingwentwrong", {state:`Please logout and try again `})
        }else {
          history("/somethingwentwrong", {state:`${constants.WFM_GET_DIV_APP_LOC_CTL}...failed`})
          }
      });
      
    
      
    }



  }

  const columns = [
    { field: 'division', headerName: 'Division', width: "200" },
    { field: 'workSchedule', headerName: 'Work Schedule', width: "280" },
    { field: 'ruleid', headerName: 'Rule ID', width: "60" },
    { field: 'groupid', headerName: 'Group ID', width: "80" },
    { field: 'location', headerName: 'Location', width: "70" },
    { field: 'schedule_area', headerName: 'Scheduled Area', width: "150" },
    { field: 'effectiveDate', headerName: 'Effective Date', width: "120" },
    {
      field: 'actions', headerName: 'View Details', width: "100", renderCell: (params) => {
        var result = searchApiValue.find(function (e) {
          return e.workSchedule == params.row.workSchedule;
        });
        return (<div>
          <IconButton
            aria-label="more"
            id="long-button"
            aria-controls={openOption ? 'long-menu' : undefined}
            aria-expanded={openOption ? 'true' : undefined}
            aria-haspopup="true"
            onClick={(event) => handleClick(event, result)}
          >
            <MoreVertIcon /> <div></div>
          </IconButton>
          <Menu
            id="long-menu"
            MenuListProps={{
              'aria-labelledby': 'long-button',
            }}
            anchorEl={anchorEl}
            open={openOption}
            onClose={handleClose}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
                width: '15ch',
              },
            }}
          >
            {options.map((option) => (
              <>

                <MenuItem key={option}
                  value={option} className={classes.menu_item} onClick={(event) => handleOptionMenuClick(event)} >
                  {option}
                </MenuItem>

              </>
            ))}
          </Menu>
        </div>)
      }
    },
  ];

  //------
  const handleSearch = () => {
    if (divSelectedValue == null) {
      setAlertOpen({
        open: true,
        severity: 'error',
        message: 'Please select division',
      });
      return;
    }

    if (isString(ruleId)) {

      setAlertOpen({
        open: true,
        severity: "error",
        message: "Rule ID should be numeric.",
      });
      return;
    }

    if (isString(groupId)) {

      setAlertOpen({
        open: true,
        severity: "error",
        message: "Group ID should be numeric.",
      });
      return;
    }

    if (isString(searchLocation)) {

      setAlertOpen({
        open: true,
        severity: "error",
        message: "Location should be numeric.",
      });
      return;
    }

    if (isString(scheduleArea)) {

      setAlertOpen({
        open: true,
        severity: "error",
        message: "Schedule Area should be numeric.",
      });
      return;
    }

    // data for searching
    let momentEffectiveDate = effectiveDate !== null ? moment(effectiveDate).format('YYYY-MM-DD') + " 00:00:00" : effectiveDate;
    let data = {
      divNbr: divSelectedValue.divNbr,
      workSchedule: workSchedule,
      ruleId: ruleId,
      groupId: groupId,
      locNbr: searchLocation,
      dptNbr: scheduleArea,
      effectiveDate: momentEffectiveDate,
      displayDiv: divSelectedValue.divNbr + "-" + divSelectedValue.divName

    }

    axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_COMMON_ADVANCESEARCH}`,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token,
        }
      }).then((res) => {

        let tmparr = []
        console.log("response", res.data);
        let a = 1;
        res.data.map(obj => {
          let tmpobj = {}
          tmpobj.id = a;
          tmpobj.division = obj.displayDiv;
          tmpobj.workSchedule = obj.workSchedule;
          tmpobj.location = obj.locNbr;
          tmpobj.schedule_area = obj.dptNbr;
          tmpobj.groupid = obj.groupId;
          tmpobj.ruleid = obj.ruleId;
          tmpobj.effectiveDate = obj.effectiveDateString;

          tmparr.push(tmpobj);
          a++;

        });
        setSearchValue(tmparr);
        setSearchApiValue(res.data);
        //console.log(tmparr)
      }).catch((err) => {
        if (err.message === 'Network Error') {
          history("/somethingwentwrong", { state: `Please logout and try again ` })
        } else {
          history("/somethingwentwrong", { state: `${constants.WFM_AVLL_RULE_ASSIGN_SEARCH}...failed` })
        }
      });


  };



  return (<div className={classes.pagemargin}>
    <div className={classes.pagetitle}>Advance Search</div>
    <div className={classes.searchbox}>
      <SnackBar
        open={open}
        message={message}
        severity={severity}
        onClose={handleAlertNotifClose}
      ></SnackBar>

      <Grid container spacing={3}>
        <Grid key={0} item xs={2} >
          <DivisionDropDownComp
            onDivChange={(e) => onDivDropDownSelect(e)}
          ></DivisionDropDownComp>
        </Grid>
        <Grid key={1} item xs={4}>
          <FormControl style={{ minWidth: "100%" }}>
            <TextField
              label="Work Schedule (Opt)"
              onChange={(e) => setWorkSchedule(e.target.value)}
              value={workSchedule}
            />
          </FormControl>
        </Grid>
        <Grid key={2} item xs={2} >
          <FormControl style={{ minWidth: "100%" }}>
            <TextField
              label="Rule Id (Opt)"
              onChange={(e) => setRuleId(e.target.value)}
              value={ruleId}
            />
          </FormControl>
        </Grid>
        <Grid key={3} item xs={2} >
          <FormControl style={{ minWidth: "100%" }}>
            <TextField
              label="Group Id (Opt)"
              onChange={(e) => setGroupId(e.target.value)}
              value={groupId}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container spacing={3} style={{ marginTop: 10 }}>
        <Grid key={1} item xs={2} >
          <FormControl style={{ minWidth: "100%" }}>
            <TextField
              label="Location (Opt)"
              onChange={(e) => setSearchLocation(e.target.value)}
              value={searchLocation}
            />
          </FormControl>
        </Grid>
        <Grid key={4} item xs={4} >
          <FormControl style={{ minWidth: "100%" }}>
            <TextField
              label="Schedule Area (Opt)"
              onChange={(e) => setScheduleArea(e.target.value)}
              value={scheduleArea}
            />
          </FormControl>
        </Grid>

        <Grid key={5} item xs={2} >
          <FormControl style={{ minWidth: "100%" }} >
            <DatePicker
              label="Effective Date (Opt)"
              renderInput={(params) => (
                <TextField {...params} />
              )}
              inputFormat="MM/dd/yyyy"
              value={effectiveDate}
              onChange={(newValue) => {
                setEffectiveDate(newValue);
              }}


            />

          </FormControl>
        </Grid>


        <Grid key={6} item xs={2} >
          <Button
            style={{
              marginLeft: "0px",
              paddingTop: "14px",
              paddingBottom: "14px",
              paddingLeft: "80px",
              paddingRight: "80px",
              marginRight: "5px",
            }}
            onClick={handleSearch}
          >
            Search
          </Button>
        </Grid>
      </Grid>
    </div>
    <AdminControlsDataGrid columns={columns} rows={searchValue} width={"90%"} />
  </div>
  );
};

export default AdvanceSearch;

